module.exports = __webpack_public_path__ + "img/NWS_Design.65aef7cb.png";